module.exports = __webpack_public_path__ + "static/media/14_pol_0_84.54.828882e1.png";